import { config } from "~/lib/config"

/**
 * Maze universal snippet (in-product surveys, e.g. NPS). Isomorphic like
 * facebookPixel.ts: rendered into the prerendered `<head>`, so it can't live
 * in a `.client` module. Survey targeting is configured in Maze, not here.
 */
const MAZE_API_KEY = "632571f0-5ac5-44b8-afe6-0d72fa21d3b7"

const MAZE_SNIPPET = `(function(m,a,z,e){var s,t,u,v;try{t=m.sessionStorage.getItem('maze-us');}catch(err){}if(!t){t=new Date().getTime();try{m.sessionStorage.setItem('maze-us',t);}catch(err){}}u=document.currentScript||(function(){var w=document.getElementsByTagName('script');return w[w.length-1];})();v=u&&u.nonce;s=a.createElement('script');s.src=z+'?apiKey='+e;s.async=true;if(v)s.setAttribute('nonce',v);a.getElementsByTagName('head')[0].appendChild(s);m.mazeUniversalSnippetApiKey=e;})(window,document,'https://snippet.maze.co/maze-universal-loader.js','${MAZE_API_KEY}');`

// Production builds only; staging and local never load Maze.
export const mazeSnippet = (): string | null =>
  config.isProduction() ? MAZE_SNIPPET : null
